import { ScoreSetEventsData } from '@/modules/epoch/types';
import { HypnogramEvent, ScoreSetHypnogramConfig } from '../../data-access';
import { ScoreSet } from '@/modules/score-set/types';
import { i18n } from '@/common/utils';

export const HYPNOGRAM_EVENTS = ['Unstaged', 'Wake', 'REM', 'N1', 'N2', 'N3'];

export const getData = (
  { measurementStart, measurementEnd, lightsOff, lightsOn, ...scoreSet }: ScoreSet,
  events: ScoreSetEventsData
): ScoreSetHypnogramConfig => {
  const { t } = i18n.global;

  const data = Object.keys(events)
    .reduce((acc, eventType) => {
      if (!Array.isArray(events[eventType])) {
        return acc;
      }

      return [
        ...acc,
        ...events[eventType].map((event) => {
          const start = new Date(event.start).getTime() / 1000;
          return {
            id: event.id,
            start: start,
            end: start + event.duration,
            duration: event.duration,
            eventType
          };
        })
      ];
    }, [] as HypnogramEvent[])
    .sort((a, b) => a.start - b.start);

  return {
    ...scoreSet,
    data,
    start: new Date(measurementStart).getTime() / 1000,
    end: new Date(measurementEnd).getTime() / 1000,
    lights: [
      {
        label: t('lightsOff'),
        x: new Date(lightsOff).getTime() / 1000
      },
      {
        label: t('lightsOn'),
        x: new Date(lightsOn).getTime() / 1000
      }
    ]
  };
};
